import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { IOfficeProps } from '../components/office/office';

export class OfficeModel extends ContentItem {
  get name(): string {
    return get(this._config, 'elements.name.value', '');
  }

  get address(): string {
    return get(this._config, 'elements.address.value', '');
  }

  get phone(): string {
    return get(this._config, 'elements.phone.value', '');
  }

  get email(): string {
    return get(this._config, 'elements.email.value', '');
  }

  public static create(data: IOffice): IOfficeProps {
    const { name, address, email, phone } = new OfficeModel(data);
    return {
      name,
      address,
      phone,
      email
    };
  }
}
